var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Metrika } from '../classes/index';
import { YandexGames } from './YandexGames';
import * as Backend from '../../backend-api';
var LeaderBoard = /** @class */ (function () {
    function LeaderBoard() {
    }
    LeaderBoard.setScore = function (name, score, force, vkUrl) {
        if (force === void 0) { force = false; }
        if (vkUrl === void 0) { vkUrl = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var params, init;
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, YandexGames.safeSetLeaderboardScore(name, score, undefined, force)];
                }
                if (FOR_VK) {
                    params = new URLSearchParams(location.search);
                    if (params.has('viewer_id')) {
                        init = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ user_id: params.get('viewer_id'), score: score }),
                        };
                        fetch(vkUrl, init)
                            .then(function (res) { return res.json(); })
                            .then(function (res) {
                            var _a;
                            if (res.error) {
                                console.log(res.error);
                                // TODO убрать после сбора статистики
                                Metrika.params({ errors: (_a = {}, _a[res.error.error_msg || "code-".concat(res.error.error_code)] = 1, _a) });
                            }
                            else {
                                console.log(res);
                            }
                        })
                            .catch(function (err) {
                            console.error(err);
                        });
                        Backend.setScore(score);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    LeaderBoard.getScore = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var entry, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, YandexGames.getLeaderboardPlayerEntry(name)];
                    case 2:
                        entry = _a.sent();
                        return [2 /*return*/, entry.score];
                    case 3:
                        err_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, 0];
                }
            });
        });
    };
    LeaderBoard.getEntries = function (name, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, YandexGames.getLeaderboardEntries(name, options)];
                }
                else if (FOR_VK) {
                    return [2 /*return*/, Backend.getLeaderBoard()];
                }
                return [2 /*return*/];
            });
        });
    };
    return LeaderBoard;
}());
export { LeaderBoard };
